import { API } from './axiosInstance'

export const sendForm = (fields) =>
  API.post(`/email/send-user-mail`, fields).then(res => res.data)